import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const PartnerInfoGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 40px',
  gap: '32px 16px',
});
